import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FolderOpen, Settings, FileText } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Drive Explorer', icon: FolderOpen },
    { path: '/operations', label: 'File Operations', icon: Settings },
    { path: '/summary', label: 'Summaries', icon: FileText },
  ];

  return (
    <nav className="bg-white shadow-lg border-b">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
          <img src="/logo.png" alt="Logo" className="h-8 w-8 mr-2" />
            <h1 className="text-xl font-bold text-gray-800">
              WhatsApp Drive Assistant
            </h1>
          </div>
          
          <div className="flex space-x-1">
            {/* {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-white'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  }`}
                >
                  <Icon className="w-4 h-4 mr-2" />
                  {item.label}
                </Link>
              );
            })} */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
